// src/components/messages/SharedPostPreview.js
import React from 'react';
import './SharedPostPreview.css';
import { useNavigate } from 'react-router-dom';
import placeholderProfile from '../../assets/placeholder-profile.png';
import goldTickIcon from '../../assets/goldtick-icon.png';
import {
  getPostStyleCssVars,
  isValidPostStyleTheme,
} from '../../constants/postStyleThemes';

function SharedPostPreview({ post, onOpenPost }) {
  const navigate = useNavigate();
  if (!post) return null;

  const {
    _id,
    content,
    text,
    username,
    name,
    profilePic,
    media = [],
    mediaType,
    thumbnail,
    thumbnails,
    adminRole,
    isAdmin,
    accountType,
    isApp,
    style,
    backgroundTheme,
    hasPaidStyle,
  } = post;


  const resolvedAdminRole = adminRole ?? post?.user?.adminRole ?? null;
  const resolvedIsAdmin =
    isAdmin === true ||
    post?.user?.isAdmin === true ||
    !!resolvedAdminRole;

  const resolvedAccountType =
    accountType ||
    post?.user?.accountType ||
    'primary';

  const resolvedIsApp =
    isApp === true ||
    post?.user?.isApp === true ||
    resolvedAccountType === 'app';

  const isSpecialUser = resolvedIsAdmin || resolvedIsApp;


  const resolvedBackgroundTheme =
    style?.backgroundTheme ||
    backgroundTheme ||
    post?.postStyle?.backgroundTheme ||
    'normal';


const safeBackgroundTheme = isValidPostStyleTheme(resolvedBackgroundTheme)
  ? resolvedBackgroundTheme
  : 'normal';

  const hasSharedPostTheme =
    safeBackgroundTheme !== 'normal' ||
    hasPaidStyle === true ||
    style?.paid === true;

const sharedPostStyleVars = getPostStyleCssVars(safeBackgroundTheme);

  const specialTitle = resolvedIsAdmin
    ? resolvedAdminRole || 'Admin'
    : resolvedIsApp
    ? 'App account'
    : '';

  console.log('[SharedPostPreview] post meta:', {
    username,
    name,
    adminRole,
    isAdmin,
    accountType,
    isApp,
    nestedUser: post?.user,
    resolvedAdminRole,
    resolvedIsAdmin,
    resolvedAccountType,
    resolvedIsApp,
    showGoldTick: isSpecialUser,
  });

  const postId =
    _id ||
    post.id ||
    post.postId ||
    (post.post && (post.post._id || post.post.id)) ||
    null;

  const isStory = mediaType?.startsWith('story');
  const baseType = isStory ? mediaType.replace('story_', '') : mediaType;

  const poster =
    thumbnail ||
    (Array.isArray(thumbnails) && thumbnails[0]) ||
    null;

  const hasMedia = Array.isArray(media) && media[0];
  const mediaUrl = hasMedia ? media[0] : null;

  const goToPost = () => {
    if (typeof onOpenPost === 'function') {
      onOpenPost();
      return;
    }

    if (postId) {
      navigate(`/post/${postId}`);
      return;
    }

    if (username) {
      navigate(`/user/${username}`, {
        state: { scrollToPostId: _id || null },
      });
    }
  };

  return (

<div
  className={`shared-post-preview shared-post-theme-${safeBackgroundTheme} ${
    hasSharedPostTheme ? 'shared-post-has-background-theme' : ''
  }`}
  style={sharedPostStyleVars}
  onClick={goToPost}
>

     <div className="shared-post-header">
        <img
          src={profilePic || placeholderProfile}
          alt="avatar"
          className="shared-avatar"
        />

        <div className="shared-info">
          <div className="shared-name">
            <span className="shared-name-row">
              <span>{name || 'Unnamed user'}</span>

              {isSpecialUser && (
                <img
                  src={goldTickIcon}
                  alt={resolvedIsAdmin ? 'Admin verified' : 'App verified'}
                  className="shared-gold-tick"
                  title={specialTitle}
                />
              )}
            </span>
          </div>

          <div className="shared-username">@{username}</div>
        </div>
      </div>

      <div className={`shared-post-body ${isStory ? 'shared-post-body--story' : ''}`}>
        {isStory ? (
          <>
            {baseType === 'image' && mediaUrl && (
              <div className="shared-story-wrap">
                <img src={mediaUrl} alt="story" className="shared-story-media" />
                <div className="shared-story-overlay">
                  <div className="shared-story-gradient" />
                  {text && <div className="shared-story-text">{text}</div>}
                </div>
              </div>
            )}

            {baseType === 'video' && mediaUrl && (
              <div className="shared-story-wrap">
                <video
                  className="shared-story-media"
                  src={mediaUrl}
                  poster={poster || undefined}
                  muted
                  playsInline
                  preload="metadata"
                />
                <div className="shared-story-overlay">
                  <div className="shared-story-gradient" />
                  {text && <div className="shared-story-text">{text}</div>}
                </div>
              </div>
            )}

            {!hasMedia && (
              <>
                {content && <p className="shared-post-text">{content}</p>}
                {text && <p className="shared-post-caption">“{text}”</p>}
              </>
            )}
          </>
        ) : (
          <>
            {text && <p className="shared-post-caption">{text}</p>}
            {content && <p className="shared-post-text">{content}</p>}

            {baseType === 'image' && mediaUrl && (
              <img src={mediaUrl} alt="shared" className="shared-post-image" />
            )}

            {baseType === 'video' && mediaUrl && (
              <video
                className="shared-post-video"
                src={mediaUrl}
                poster={poster || undefined}
                muted
                playsInline
                preload="metadata"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default SharedPostPreview;
